(() => {
  document.querySelectorAll('[data-eg-shared-header]').forEach(header=>{
    if(header.dataset.egHeaderReady)return;
    header.dataset.egHeaderReady='true';
    const count=header.querySelector('[data-eg-header-count]');
    const nativeCount=document.querySelector('[data-section-type="header"] [data-js-cart-count]');
    if(count&&nativeCount){
      const sync=()=>{const value=nativeCount.textContent.trim();if(/^\d+$/.test(value))count.textContent=value;};
      sync();new MutationObserver(sync).observe(nativeCount,{childList:true,subtree:true,characterData:true});
    }
    const apparel=header.querySelector('.eg-shared-header__apparel');
    if(apparel){
      document.addEventListener('click',event=>{if(apparel.open&&!apparel.contains(event.target))apparel.open=false;});
      apparel.addEventListener('keydown',event=>{if(event.key==='Escape'&&apparel.open){event.preventDefault();apparel.open=false;apparel.querySelector('summary').focus();}});
      apparel.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{apparel.open=false;}));
    }
  });
})();
